import { useContext } from 'react';
import {
  SelectedTransactionContext,
  SelectedTransactionContextType,
} from 'src/context/selected-transaction-context';

export function useSelectedTransactions(): SelectedTransactionContextType {
  const transactionsContext = useContext(SelectedTransactionContext);

  if (transactionsContext) {
    return transactionsContext;
  }

  throw new Error(
    'Revamp: useSelectedTransactions should be used inside the SelectedTransactionProvider.',
  );
}
